import axios from "services/setupAxios";
import {MANAGE_USER_ACCESS} from "utils/request";


export const updateUserInfo = (payload) => {
    return axios.post(MANAGE_USER_ACCESS, payload);
};